// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__31HTY","inputDescription":"styles_inputDescription__3_Z_u"};